import { render, staticRenderFns } from "./credentials.vue?vue&type=template&id=d95a96e8&"
import script from "./credentials.vue?vue&type=script&lang=js&"
export * from "./credentials.vue?vue&type=script&lang=js&"
import style0 from "./credentials.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports